import { NotifyHelper } from 'classes/helpers/notify.helper';
import { Controller } from 'lib_ts/enums/routing/controllers';
import { CustomerApiRoutes } from 'lib_ts/enums/routing/routes/customer-api';
import { IApiKey } from 'lib_ts/interfaces/api/key';
import { IServerResponse } from 'lib_ts/interfaces/common/i-server-response';
import { BaseRESTService } from 'services/_base-rest.service';

export class CustomerApiService extends BaseRESTService {
  private static instance: CustomerApiService;
  static getInstance(): CustomerApiService {
    if (!CustomerApiService.instance) {
      CustomerApiService.instance = new CustomerApiService();
    }

    return CustomerApiService.instance;
  }

  private constructor() {
    super({
      controller: Controller.CustomerV1,
    });
  }

  async getKeys(): Promise<IApiKey[]> {
    return await this.get({
      uri: CustomerApiRoutes.GetKeys,
      params: {
        exclude_disabled: true,
      } as any,
    })
      .then((result: IServerResponse) => {
        if (!result.success) {
          NotifyHelper.warning({
            message_md:
              result.error ?? 'There was an error retrieving your API keys.',
          });
          return [];
        }

        return result.data as IApiKey[];
      })
      .catch((error) => {
        console.error(error);
        NotifyHelper.error({
          message_md: 'There was an error retrieving your API keys.',
        });
        return [];
      });
  }

  async generateKey(data: Partial<IApiKey>): Promise<IApiKey | undefined> {
    return await this.post(
      {
        uri: CustomerApiRoutes.GenerateKey,
      },
      data
    )
      .then((result: IServerResponse) => {
        if (!result.success) {
          NotifyHelper.warning({
            message_md:
              result.error ?? 'There was an error generating an API key.',
          });
          return undefined;
        }

        return result.data as IApiKey;
      })
      .catch((error) => {
        console.error(error);
        NotifyHelper.error({
          message_md: 'There was an error generating an API key.',
        });
        return undefined;
      });
  }

  async revokeKey(data: Partial<IApiKey>): Promise<boolean> {
    return await this.post(
      {
        uri: CustomerApiRoutes.RevokeKey,
      },
      data
    )
      .then((result: IServerResponse) => {
        if (!result.success) {
          NotifyHelper.warning({
            message_md:
              result.error ?? 'There was an error revoking your API key.',
          });
          return false;
        }

        return true;
      })
      .catch((error) => {
        console.error(error);
        NotifyHelper.error({
          message_md: 'There was an error revoking your API key.',
        });
        return false;
      });
  }
}
